import React, { useEffect, useState } from "react";
import { Button, Stack, TextField } from "@mui/material";
import styles from "../forgotpassword/forget.module.scss";
import { MdClose } from "react-icons/md";
import toast from "react-hot-toast";
import { sendResetPasswordLink } from "../../Api/forgotpasswordAPI";
import { getAccessTokenAPI } from "Api/getAccessToken";
import { useGlobalContext } from "context/globalContext";
import { APP_URL } from "constants/environment";
import { consoleLog } from "helpers";
export default function ForgetPasswordDialog({ onClose }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { accessJWT, setAccessJWT } = useGlobalContext();
  consoleLog([accessJWT]);

  const [email, setEmail] = React.useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  consoleLog([isLoading]);
  const [loginCreateAccountState, setLoginCreateAccountState] = useState({
    flag: false,
    page: "",
  });

  function handleCancel() {
    if (onClose) {
      onClose();
    }
  }

  useEffect(() => {
    async function getAccessToken() {
      let success = false;
      let count = 0;
      while (!success && count <= 4) {
        try {
          const response = await getAccessTokenAPI();
          if (response?.statusCode === 200 && response?.data) {
            setAccessJWT(response?.data);
            localStorage.setItem("jwtToken", response?.data);
            success = true;
          }
        } catch (err) {
          console.error("Error fetching access token:", err);
        }
        count++;
      }
    }

    getAccessToken();
  }, []);

  async function handleSendResetPasswordLink() {
    const token = localStorage.getItem("jwtToken");

    if (!token) {
      toast.error("Please wait... Setting up access. Try again in a moment.");
      return;
    }

    try {
      const payload = {
        email: email.toLowerCase().trim(),
        redirectUrl: `${APP_URL}`,
      };

      const response = await sendResetPasswordLink(
        payload,
        setIsLoading,
        token
      );

      if (response) {
        toast.success("Reset link sent successfully.");
        setLoginCreateAccountState({ ...loginCreateAccountState, flag: false });
        if (onClose) {
          onClose();
        }
      } else {
        toast.error("Oops! Failed to send reset link.");
      }
    } catch (error) {
      console.error("Reset Password Error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack className={styles.main}>
        <Stack className={styles.container}>
          <Stack
            px={{ xs: 3, sm: 3, md: 3, lg: 0, xl: 0 }}
            className={styles.subContainer}
          >
            <Stack className={styles.card}>
              <MdClose className={styles.closeIcon} onClick={handleCancel} />
            </Stack>

            <Stack
              sx={{
                width: "100%",
                maxHeight: {
                  sm: "80vh",
                  xs: "80vh",
                  md: "calc(100% - 5%)",
                  lg: "calc(100% - 5%)",
                },
                overflow: "auto",
                bgcolor: "#f8f8f8",
                borderRadius: "8px",
              }}
            >
              <Stack padding={3} spacing={3}>
                <Stack spacing={2} sx={{ width: "100%", pl: 2, pr: 2 }}>
                  <Stack
                    position="relative"
                    alignSelf="start"
                    sx={{ width: "100%", height: "65px" }}
                  >
                    <h2
                      style={{
                        fontSize: "10px",
                        marginBottom: "6px",
                        color: "#5F6A70",
                        fontWeight: "500",
                        fontFamily: "Lato",
                        opacity: "0.9",
                      }}
                    >
                      YOUR EMAIL ADDRESS
                    </h2>
                    <TextField
                      type="text"
                      size="small"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEmailError("");
                        toast.dismiss();
                      }}
                      InputProps={{
                        style: {
                          height: "40px",
                          width: "100%",
                          fontSize: "12px",
                          backgroundColor: "white",
                          color: "#696969",
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: "12px",
                        },
                      }}
                      error={!!emailError}
                      helperText={emailError}
                    />
                  </Stack>
                </Stack>
              </Stack>

              <Button
                variant="contained"
                sx={{
                  height: 80,
                  bgcolor: "#FCB400",
                  border: "none",
                  borderRadius: "0px",
                  boxShadow: "none",
                  outline: "none",
                  "&:hover": {
                    bgcolor: "#FCB400",
                  },
                }}
                onClick={handleSendResetPasswordLink}
              >
                <h5
                  style={{
                    color: "#222222",
                    fontWeight: "600",
                    fontSize: "18px",
                    fontFamily: "lato",
                  }}
                >
                  Send
                </h5>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}
